module.exports = __webpack_public_path__ + "static/media/10.7a96fea9.jpg";